<template>
  <div class="page-wrapper">
    <v-col cols="12" lg="10" md="7">
      <v-form>
        <v-card class="card-shadow bg-secondary">
          <CadastroAcessoPerfil />
        </v-card>
      </v-form>
    </v-col>
  </div>
</template>
<script>
import CadastroAcessoPerfil from "../Components/Cadastros/CadastroAcessoPerfil.vue";

export default {
  name: "RegisterProfileAccess",
  components: {
    CadastroAcessoPerfil,
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.page-wrapper {
  display: flex;
  justify-content: center;
}
</style>
